export default __webpack_public_path__ + "static/media/rgp_pvh_nca_karaganda_region.9c531374.png";